import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { publicRoute } from '../../router/parents';
import { ForgotPasswordPage, InvitePage, LoginPage, ResetPasswordPage, SignupPage, VerifyEmailPage } from './auth';
import { BookingPage, ManageBookingPage } from './booking';
import { FirmPage } from './firm';
import { FollowupPage, IntakePage } from './intake';
import { LandingPage, PricingPage } from './landing';
import { DevCheckoutPage, PayPage, PaySuccessPage } from './pay';
import { PortalSignInPage, PortalVerifyPage } from './portal-entry';

const parent = () => publicRoute;

export const publicRoutes: AnyRoute[] = [
  createRoute({ getParentRoute: parent, path: '/', component: LandingPage }),
  createRoute({ getParentRoute: parent, path: '/pricing', component: PricingPage }),
  createRoute({ getParentRoute: parent, path: '/signup', component: SignupPage }),
  createRoute({ getParentRoute: parent, path: '/login', component: LoginPage }),
  createRoute({ getParentRoute: parent, path: '/invite/$token', component: InvitePage }),
  createRoute({ getParentRoute: parent, path: '/verify-email', component: VerifyEmailPage }),
  createRoute({ getParentRoute: parent, path: '/forgot-password', component: ForgotPasswordPage }),
  createRoute({ getParentRoute: parent, path: '/reset-password', component: ResetPasswordPage }),
  createRoute({ getParentRoute: parent, path: '/f/$slug', component: FirmPage }),
  createRoute({ getParentRoute: parent, path: '/intake/followup/$token', component: FollowupPage }),
  createRoute({ getParentRoute: parent, path: '/intake/$slug/$formSlug', component: IntakePage }),
  createRoute({ getParentRoute: parent, path: '/book/$slug/$typeSlug', component: BookingPage }),
  createRoute({ getParentRoute: parent, path: '/booking/manage/$token', component: ManageBookingPage }),
  createRoute({ getParentRoute: parent, path: '/pay/success', component: PaySuccessPage }),
  createRoute({ getParentRoute: parent, path: '/pay/dev-checkout/$sessionId', component: DevCheckoutPage }),
  createRoute({ getParentRoute: parent, path: '/pay/$token', component: PayPage }),
  createRoute({ getParentRoute: parent, path: '/portal/verify', component: PortalVerifyPage }),
  createRoute({ getParentRoute: parent, path: '/portal/$slug', component: PortalSignInPage }),
];
